import React from "react";
import { ChevronRight } from "lucide-react";

/**
 * @param {{
 *   ariaLabel: string,
 *   items: Array<{
 *     key: string,
 *     label: string,
 *     icon?: React.ComponentType<{ size?: number, strokeWidth?: number, "aria-hidden"?: boolean|string }>,
 *     href?: string,
 *     onClick?: () => void,
 *     disabled?: boolean,
 *     as?: React.ElementType,
 *   }>,
 * }} props
 */
export function AppHubSecondaryNav({ ariaLabel, items = [] }) {
  return (
    <section className="mm-hub__secondary" aria-label={ariaLabel}>
      {items.map((item) => {
        const Icon = item.icon;
        const Comp = item.as || (item.href ? "a" : "button");
        const disabled = Boolean(item.disabled);
        if (disabled) {
          return (
            <span
              key={item.key}
              className="mm-hub__secondaryBtn mm-hub__secondaryBtn--disabled"
              aria-disabled="true"
            >
              {Icon ? (
                <Icon size={18} strokeWidth={2} aria-hidden="true" />
              ) : null}
              <span>{item.label}</span>
              <ChevronRight size={16} strokeWidth={2} aria-hidden="true" />
            </span>
          );
        }
        const isNativeButton = Comp === "button";
        const isAnchor = Comp === "a";
        const props = isNativeButton
          ? { type: "button", onClick: item.onClick }
          : isAnchor
            ? { href: item.href, onClick: item.onClick }
            : { to: item.href, onClick: item.onClick };
        return (
          <Comp key={item.key} className="mm-hub__secondaryBtn" {...props}>
            {Icon ? (
              <Icon size={18} strokeWidth={2} aria-hidden="true" />
            ) : null}
            <span>{item.label}</span>
            <ChevronRight size={16} strokeWidth={2} aria-hidden="true" />
          </Comp>
        );
      })}
    </section>
  );
}
